"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Slider = (function (_a) {
    var disabled = _a.disabled, className = _a.className, paintProgress = _a.paintProgress, vertical = _a.vertical, value = _a.value, onChange = _a.onChange;
    var _b = __read((0, react_1.useState)(false), 2), moving = _b[0], setMoving = _b[1];
    var _c = __read((0, react_1.useState)(0), 2), position = _c[0], setPosition = _c[1];
    var handleRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!moving && value !== undefined && value !== null) {
            setPosition(value);
        }
    }, [moving, value]);
    (0, react_1.useEffect)(function () {
        var mouseUpHandler = function () {
            setMoving(false);
        };
        var mouseMoveHandler = function (e) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (moving) {
                var totalWidth = (((_b = (_a = handleRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0);
                var totalHeight = (((_d = (_c = handleRef.current) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.clientHeight) || 0);
                var x = e.clientX;
                var y = e.clientY;
                var left = (((_f = (_e = handleRef.current) === null || _e === void 0 ? void 0 : _e.parentElement) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect().left) || 0);
                var bottom = (((_h = (_g = handleRef.current) === null || _g === void 0 ? void 0 : _g.parentElement) === null || _h === void 0 ? void 0 : _h.getBoundingClientRect().bottom) || 0);
                var newPosition_1 = vertical ? (bottom - y) / totalHeight : (x - left) / totalWidth;
                if (newPosition_1 < 0) {
                    newPosition_1 = 0;
                }
                if (newPosition_1 > 1) {
                    newPosition_1 = 1;
                }
                setPosition(function (prevState) {
                    if (prevState !== newPosition_1) {
                        onChange(newPosition_1);
                    }
                    return newPosition_1;
                });
            }
        };
        document.addEventListener("mouseup", mouseUpHandler);
        document.addEventListener("mousemove", mouseMoveHandler);
        return function () {
            document.removeEventListener("mouseup", mouseUpHandler);
            document.removeEventListener("mousemove", mouseMoveHandler);
        };
    }, [moving, vertical, onChange]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-slider", disabled && "disabled", vertical && "ui-slider-vertical", className) },
        paintProgress && (react_1.default.createElement("div", { className: "ui-slider-progress", style: {
                width: !vertical ? "".concat(position * 100, "%") : undefined,
                height: vertical ? "".concat(position * 100, "%") : undefined,
            } })),
        react_1.default.createElement("div", { ref: handleRef, className: "ui-slider-handle", role: "slider", onMouseDown: function () {
                if (!disabled) {
                    setMoving(true);
                }
            }, style: {
                left: !vertical ? "calc(".concat(position * 100, "% - 8px)") : undefined,
                bottom: vertical ? "calc(".concat(position * 100, "% - 8px)") : undefined,
            } })));
});
exports.default = Slider;
